<template>
  <div class="app-container">
    <!-- 搜索区 -->
    <el-card shadow="never" class="filter-card">
      <el-form :inline="true" :model="queryParams" size="small" class="filter-form">
        <el-form-item label="变动类型">
          <el-select v-model="queryParams.operation_type" placeholder="全部" clearable @change="handleQuery">
            <el-option label="增加" value="1" />
            <el-option label="减少" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="月份">
          <el-date-picker v-model="queryParams.time" type="month" placeholder="选择月份"
            value-format="yyyy-MM" @change="handleQuery" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card shadow="never" class="table-card">
      <el-table :key="tableKey" v-loading="listLoading" :data="list" border stripe
        highlight-current-row style="width: 100%;">
        <el-table-column label="序号" type="index" align="center" width="55" />
        <el-table-column label="头像" align="center" width="70">
          <template slot-scope="{row}">
            <img v-if="row.avatar" :src="row.avatar" style="width: 40px; height: 40px; border-radius: 50%;">
            <img v-else src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" style="width: 40px; height: 40px; border-radius: 50%;">
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="title" align="center" min-width="180" show-overflow-tooltip />
        <el-table-column label="变动金额" align="center" width="120">
          <template slot-scope="{row}">
            <span :class="isAdd(row.type) ? 'amount-add' : 'amount-sub'">
              {{ isAdd(row.type) ? '+' : '-' }}{{ row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center" width="170">
          <template slot-scope="{row}">
            <span>{{ row.create_time }}</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.page"
        :limit.sync="queryParams.limit" @pagination="getList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { postAction } from '@/api/user'

export default {
  name: 'ScoreDetail',
  components: { Pagination },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: false,
      queryParams: {
        page: 1,
        limit: 10,
        type: 1, // 固定积分
        operation_type: '',
        time: ''
      }
    }
  },
  created() {
    const now = new Date()
    this.queryParams.time = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      try {
        const params = { ...this.queryParams }
        if (!params.operation_type) delete params.operation_type
        if (!params.time) delete params.time

        const res = await postAction('/api/user/getLogList', params)
        if (res.code === 200) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取数据失败')
        }
      } catch {
        this.$message.error('获取数据失败')
      } finally {
        this.listLoading = false
      }
    },
    isAdd(type) {
      return type <= 100
    },
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = { page: 1, limit: 10, type: 1, operation_type: '', time: '' }
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px;
}

.filter-card {
  margin-bottom: 16px;

  ::v-deep .el-card__body {
    padding: 16px 20px 0;
  }

  .filter-form .el-form-item {
    margin-bottom: 16px;
  }
}

.table-card {
  ::v-deep .el-card__body {
    padding: 0 20px 16px;
  }
}

.amount-add { color: #67c23a; font-weight: 600; }
.amount-sub { color: #f56c6c; font-weight: 600; }

@media (max-width: 768px) {
  .app-container { padding: 8px; }
  .filter-card ::v-deep .el-card__body { padding: 12px 12px 0; }
  .table-card ::v-deep .el-card__body { padding: 0 8px 12px; }
}
</style>
